export { colors, type Colors } from './colors.js'
export { typography, type Typography } from './typography.js'
export { spacing, sizes, type Spacing, type Sizes } from './spacing.js'
export { animation, type Animation } from './animation.js'

import { colors } from './colors.js'
import { typography } from './typography.js'
import { spacing, sizes } from './spacing.js'
import { animation } from './animation.js'

// Combined tokens object for easy access
export const tokens = {
  colors,
  typography,
  spacing,
  sizes,
  animation
} as const